import React, { useEffect, useState, useRef } from 'react';
import { registerLicense } from '@syncfusion/ej2-base';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import logo from './static/images/beam-logo.png';
import RidesPaymentCalculation from './pages/RidesPaymentCalculation/RidesPaymentCalculation';
import { DateToString } from './components/utils/utils'

// import GridTest from './pages/GridTest';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import '@syncfusion/ej2-base/styles/bootstrap.css';
import '@syncfusion/ej2-buttons/styles/bootstrap.css';
import '@syncfusion/ej2-inputs/styles/bootstrap.css';
import '@syncfusion/ej2-popups/styles/bootstrap.css';
import '@syncfusion/ej2-react-calendars/styles/bootstrap.css';

import './App.css';

function App() {
  // Registering Syncfusion license key
  registerLicense(process.env.REACT_APP_SYNCFUSION_KEY);
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* <Route path="/grid" element={<GridTest />} /> */}
          <Route path="/rides-payment-calculation" element={<RidesPaymentCalculation />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

function Home() {
  const navigate = useNavigate();
  const [validDates, setValidDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const datePickerRef = useRef(null);

  const START_RIDES_DATE_QUINCY = process.env.REACT_APP_START_RIDES_DATE_QUINCY;
  const org = process.env.REACT_APP_ORGANIZATION_NAME;


  useEffect(() => {
    async function fetchValidDates() {
      try {
        const response = await fetch(process.env.REACT_APP_RIDE_BACKOFFICE_SERVICE_URL + process.env.REACT_APP_VALID_RIDE_DATES_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // any other necessary headers
          },
          body: JSON.stringify({
            startDate: START_RIDES_DATE_QUINCY,  // Including the start date
          }),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log(data);
        if (data && Array.isArray(data)) { // Ensure data exists and is an array before mapping
          // setValidDates(data.map(dateString => new Date(dateString)));
          setValidDates(data);
        } else {
          console.warn("Unexpected data format:", data);
        }
      } catch (error) {
        console.error("Failed to fetch valid dates:", error);
      } finally {
        setLoading(false); // Set loading to false once done fetching, regardless of success or failure
      }
    }

    fetchValidDates();
  }, [START_RIDES_DATE_QUINCY]);

  function getDateStatus(date) {
    const dateString = DateToString(date);
    const validDate = validDates.find(vd => vd.rideDate === dateString);

    if (!validDate) return { isValid: false, isClose: false };
    return { isValid: true, isClose: validDate.operationsStatus === 'closed' };
  }

  function onRenderDayCell(args) {
    const { isValid, isClose } = getDateStatus(new Date(args.date));

    if (isValid) {
      console.log(`onRenderDayCell >> args:`, args);
      if (isClose) {
        args.element.classList.add('closedDateCalendarCell');
      } else {
        args.element.classList.add('openDateCalendarCell');
      }
    } else {
      args.isDisabled = true;
    }

  }

  function onSelectDate(args) {
    const selectedDate = args.value;
    const { isValid } = getDateStatus(selectedDate);

    if (isValid) {
      navigate(`/rides-payment-calculation?date=${DateToString(selectedDate)}`);
    }
  }

  return (
    <header className="App-header">
      <img src={logo} className="App-logo" alt="logo" />
      <p>{org} Back-Office Dashboard for Rides Payments</p>
      <div className='date-picker-holder'>
        {
          loading
            ? <p>Loading...</p>
            : (
              <div className="date-picker-inner-container">
                <span>Select Report Date:</span>
                <DatePickerComponent
                  key={`valid-ride-dates-picker-${validDates.length}`}
                  // id="valid-ride-dates-picker"
                  ref={datePickerRef}
                  strictMode={true}
                  renderDayCell={onRenderDayCell}
                  allowEdit={false}
                  change={onSelectDate}
                  onClick={() => {
                    if (datePickerRef && datePickerRef.current) {
                      datePickerRef.current.show();
                    }
                  }}
                // value={new Date(START_RIDES_DATE_QUINCY)}
                // change={onChange}
                />
              </div>
            )
        }
      </div>
    </header>
  );

}

export default App;
